import { AssetGroup } from '@play-co/timestep-core';
import { View } from '@play-co/timestep-core/ui';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import sounds from 'src/lib/sounds';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import { Feature } from 'src/replicant/analytics';
import type { CardId } from 'src/replicant/cards/cards.ruleset';
import { GENERIC_AVATAR } from 'src/replicant/profile/assets';
import { Card } from '../components/Card';

/** Arguments displayed after a card trade proposal has been sent. */
export type PopupCardTradeSentOpenArgs = {
  cardId: CardId;
  otherUserName: string;
  otherUserAvatar: string;
};

/** Informational popup shown after a trade proposal has been committed. */
export default class PopupCardTradeSent extends PopupBasic<() => void> {
  private card: Card;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: 582,
      height: 720,
      darkerBg: true,
      tracking: {
        feature: Feature.CARDS._,
        $subFeature: Feature.CARDS.SEND,
      },
    });

    this.card = new Card({
      superview: this.box,
      centerOnOrigin: true,
      x: 290,
      y: 265,
      scale: 1.25,
    });

    this.message.updateOpts({
      x: 46,
      y: 440,
      width: 490,
      height: 130,
      size: 27,
      color: '#9A7171',
      align: 'center',
      verticalAlign: 'center',
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.secondary,
      x: 161,
      y: 585,
      width: 260,
      height: 82,
      font: 'Body',
      fontSize: 32,
      labelOffsetY: -3,
      localeText: () => i18n('basic.ok'),
      tracking: {
        feature: Feature.CARDS._,
        $subFeature: Feature.CARDS.SEND,
      },
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close();
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      GENERIC_AVATAR,
      ...AssetGroup.constructURLs(['assets/ui/cards/common']),
    ]);
  }

  public init(args: PopupCardTradeSentOpenArgs) {
    super.init({
      title: i18n('cards.cardTrade.sentTitle'),
      message: i18n('cards.cardTrade.sentMessage'),
    });
    this.card.setState({ id: args.cardId, count: 1 });
  }
}
